import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'

export const EXCHANGE: Record<number, string> = {
  [ChainId.SMARTBCH]: 'emberswap/subgraphv2',
}

export const GRAPH_HOST: Record<number, string> = {
  [ChainId.SMARTBCH]: 'http://localhost:8000',
}

export const SUPPORTED_CHAINS: Array<ChainId> = [ChainId.SMARTBCH] // supported chains
